<section class="rounded-xl border border-slate-200 bg-white shadow-sm">
  <header class="border-b border-slate-200 px-6 py-5">
    <h2 class="text-base font-bold text-slate-900">Property Type</h2>
    <p class="mt-1 text-sm text-slate-500">
      CI calculation and required inputs vary depending on the property type.
    </p>
  </header>

  <div class="px-6 py-5">
    <fieldset>
      <legend class="sr-only">Property type</legend>

      <div class="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        @for (category of categories; track category.value) {
          <label
            class="cursor-pointer rounded-xl border p-5 transition-colors"
            [class]="
              selected() === category.value
                ? 'border-indigo-400 bg-indigo-50/70 ring-1 ring-indigo-400'
                : 'border-slate-200 bg-white hover:border-slate-300'
            "
          >
            <input
              type="radio"
              name="ci-property-type"
              class="sr-only"
              [value]="category.value"
              [checked]="selected() === category.value"
              (change)="selectedChange.emit(category.value)"
            />

            <span
              class="block"
              [class]="selected() === category.value ? 'text-indigo-600' : 'text-slate-400'"
            >
              @switch (category.icon) {
                @case ('building') {
                  <svg viewBox="0 0 24 24" class="size-6" fill="none" aria-hidden="true">
                    <path d="M4 21V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v16M15 21V9h4a1 1 0 0 1 1 1v11M3 21h18M7.5 8h3M7.5 12h3M7.5 16h3"
                          stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                }
                @case ('home') {
                  <svg viewBox="0 0 24 24" class="size-6" fill="none" aria-hidden="true">
                    <path d="M3 10.5 12 3l9 7.5M5.5 9.5V20a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V9.5"
                          stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                }
                @case ('land') {
                  <svg viewBox="0 0 24 24" class="size-6" fill="none" aria-hidden="true">
                    <path d="M12 3v8M12 3l3 2-3 2" stroke="currentColor" stroke-width="1.6"
                          stroke-linecap="round" stroke-linejoin="round" />
                    <path d="m3 16 9-4 9 4-9 5-9-5Z" stroke="currentColor" stroke-width="1.6"
                          stroke-linejoin="round" />
                  </svg>
                }
                @case ('layers') {
                  <svg viewBox="0 0 24 24" class="size-6" fill="none" aria-hidden="true">
                    <path d="m3 8 9-4 9 4-9 4-9-4Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
                    <path d="m3 12.5 9 4 9-4M3 17l9 4 9-4" stroke="currentColor" stroke-width="1.6"
                          stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                }
              }
            </span>

            <span class="mt-3 block text-[15px] font-bold text-slate-900">
              {{ category.label }}
            </span>
            <span class="mt-0.5 block text-sm text-slate-500">{{ category.basis }}</span>
          </label>
        }
      </div>
    </fieldset>
  </div>
</section>
